import { useEffect } from 'react';
import { gsap } from 'gsap';

export const useGiftChooseShowAnimation = ({ index, itemRef, imageRef }) => {
  useEffect(() => {
    gsap.globalTimeline.resume();

    const { current: item } = itemRef;
    const { current: img } = imageRef;

    const showTimeline = gsap.timeline({ delay: index * 0.1 });

    showTimeline
      .to(item, { scaleX: 0, scaleY: 0, opacity: 1, duration: 0 })
      .to(item, { scaleX: 1, scaleY: 0.05, duration: 0.5 })
      .to(item, { scaleX: 1, scaleY: 1, duration: 0.5 })
      .from(img, { transform: 'scale(0.3)', opacity: 0, duration: 0.5, ease: 'elastic.out(1,0.5)' });

    return () => {
      showTimeline.kill();
    };
  }, [index]);
};
